"use strict";
// @ts-ignore
try {
    self['workbox:precaching:6.5.1'] && _();
}
catch (e) { }
